import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { LeaveConfirmationDialogComponent } from './leave-confirmation-dialog.component';

@Injectable()
export class LeaveConfirmationDialogService extends AbstractDialogService<void, boolean> {
  readonly id = 'leave-confirmation-dialog';
  protected override readonly options = {
    cssClass: 'leave-confirmation-dialog auto-height action-sheet-on-mobile',
  };
  protected override readonly component = LeaveConfirmationDialogComponent;
}
